// extracted by mini-css-extract-plugin
export default {"grid_container":"card-board_grid_container__+liD1"};